import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby"
import Seo from "../components/Seo";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  PinterestShareButton,
  PinterestIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

import Layout from "../components/Layout";
import device from "../utils/device";

const Hero = styled.div`
  position: relative;
  min-width: 100%;
  min-height: 55vh;
  background-color: #141618;
`;

const ImagePlacehoder = styled.div`
  overflow: hidden;
  display: block;
  margin-bottom: 0.75rem;

  .gatsby-image-wrapper {
    opacity: 0.8;
    transition: opacity 0.5s;
    transition-delay: 0.2s;
    width: 100%;
    height: 55vh;
    /* margin-top: -10vw;
  	padding-top: 10vw; */
    transition: all 0.15s ease-in-out;
    animation: zoom 2s;
    transform: scale(1.5);
    animation-fill-mode: forwards;

    @keyframes zoom {
      100% {
        transform: scale(1, 1);
      }
    }
  }

  .gatsby-image-wrapper:hover {
    //transform: scale(1.10, 1.10);
  }
`;

const HeroContent = styled.div`
  position: absolute;
  display: table-row;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  color: white;
  text-align: center;
  // padding: 3em 2em 3em 2em;
  margin: 0 0.75em 0 0.75em;
  padding: 0;

  @media ${device.laptop} {
    font-size: 1.2em;
  }

  @media ${device.desktop} {
    font-size: 2em;
  }

  h1 {
    color: white;
    font-size: 1.5em;
    letter-spacing: -0.02em;
    @media ${device.mobileM} {
      font-size: 2em;
    }
    @media ${device.mobileL} {
      font-size: 2.2em;
    }
    @media ${device.tablet} {
      font-size: 2.5em;
    }
  }
`;

const PostSummary = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: 600;
  padding: 0 1em 0 1em;

  span {
    margin: 0px 1em 0px 1em;
    font-weight: 400;
  }
  a {
    color: white;
    margin-left: 0.75em;
  }
`;

const Content = styled.div`
  margin: 1em;

  @media ${device.tablet} {
    margin: 1em 10vw;
  }

  @media ${device.laptop} {
    margin: 1em 15vw;
  }

  @media ${device.desktop} {
    margin: 1em 25vw;
  }

  ol li,
  ul li {
    list-style: disc;
    margin-left: -1.45rem;
    padding: 0px 0px 0px 1em;
    line-height: 1.2;
  }

  p {
    line-height: 1.75;
  }

  a {
    font-weight: 600;
  }
  a:active,
  a:hover {
    color: #a7a7a7;
    outline-width: 0;
  }

  hr {
    margin-bottom: calc(1.45rem - 1px);
    background: hsla(42, 43%, 39%, 0.2);
    border: none;
    height: 1px;
  }

  li > ol,
  li > ul {
    margin-left: 1.45rem;
    margin-bottom: calc(1.45rem / 2);
    margin-top: calc(1.45rem / 2);
  }
  li > p {
    margin-bottom: calc(1.45rem / 2);
  }

  figure {
    margin: 1em 0 1em 0;
  }

  figcaption {
    color: #767676;
    font-size: 0.75em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    line-height: 1.6;
    margin: 0;
    padding: 0.5rem;
    text-align: left;
    text-align: center;
    margin-inline-start: 0px;
  }

  blockquote {
    color: #303133;
    margin: 27px 0px 27px 0px;
    padding: 0 0 0 27px;
    border-left: 2px solid;
    border-color: #787878;
    font-family: Georgia, "Times New Roman", Times, serif;
  }
  blockquote.pullquote p::before {
    font-family: Georgia, serif;
    content: open-quote;
    font-size: 1.5em;
    line-height: 0;
    vertical-align: -0.25em;
    margin-right: 0.2em;
  }
  blockquote.pullquote > p:first-of-type:after {
    font-family: Georgia, serif;
    content: close-quote;
    font-size: 1.5em;
    line-height: 0;
    vertical-align: -0.25em;
    margin-left: 0.1em;
  }
`;

const Date = styled.div`
  min-width: 7em;
  align-self: flex-start;
`;

const Categories = styled.div`
  display: flex;
`;

const Tags = styled.div`
  a {
    font-size: 11px !important;
    padding: 2px 5px 2px 5px;
    display: inline-block;
    border: 1px solid;
    border-radius: 4px;
    margin: 0px 5px 9px 0px;
    text-transform: uppercase;
    font-weight: 600;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

class PostTemplate extends Component {
  render() {
    const post = this.props.data.post;
    const imageData =
      post.featuredImage?.image?.localFile.childImageSharp.gatsbyImageData;

    // strip out noreferrer from content
    const content = parse(
      post.content.replace(/[ ]{0,}noreferrer[ ]{0,}/gi, "")
    );

    const mainImage = post.featuredImage?.image?.sourceUrl.replace(
      "/cms.1st-option.com/wp-content/uploads/",
      "/www.1st-option.com/static/blog/"
    );

    return (
      <Layout>
        <Seo
          title={(post.seo && post.seo.title) || post.title}
          description={(post.seo && post.seo.description) || post.excerpt}
          image={mainImage}
        />
        <Hero>
          {imageData ? (
            <ImagePlacehoder>
              <GatsbyImage image={imageData} />
            </ImagePlacehoder>
          ) : null}
          <HeroContent>
            <h1>{parse(post.title)}</h1>
            <PostSummary>
              <Date>{post.date}</Date>
              {post.categories && (
                <Categories>
                  <span>|</span>In
                  {post.categories.nodes.map((category) => (
                    <Link key={category.slug} to={`/${category.slug}`}>
                      {category.name}
                    </Link>
                  ))}
                </Categories>
              )}
            </PostSummary>
          </HeroContent>
        </Hero>

        <Content>
          {content}
          {post.tags && (
            <Tags>
              {post.tags.nodes.map((tag) => (
                <Link key={tag.slug} to={`/tag/${tag.slug}`} className="tags">
                  {tag.name}
                </Link>
              ))}
            </Tags>
          )}

          <SocialMedia>
            <FacebookShareButton
              url={this.props.location.href}
              quote={post.title}
              hashtag={
                post.social &&
                post.social.facebook &&
                (post.social.facebook[0] !== "#"
                  ? `#${post.social.facebook}`
                  : post.social.facebook)
              }
            >
              <FacebookIcon
                size={32}
                round
                bgStyle={{ display: "none" }}
                iconFillColor={"black"}
              />
            </FacebookShareButton>
            <TwitterShareButton
              url={this.props.location.href}
              description={post.title}
              hashtags={post.social?.twitter
                ?.split(",")
                .map((item) => item.trim())}
            >
              <TwitterIcon
                size={32}
                round
                bgStyle={{ display: "none" }}
                iconFillColor={"black"}
              />
            </TwitterShareButton>
            <PinterestShareButton
              url={this.props.location.href}
              description={post.title}
              media={imageData && imageData.src}
            >
              <PinterestIcon
                size={32}
                round
                bgStyle={{ display: "none" }}
                iconFillColor={"black"}
              />
            </PinterestShareButton>
            <WhatsappShareButton
              url={this.props.location.href}
              description={post.title}
              media
              hashtag={post.social && post.social.twitter}
            >
              <WhatsappIcon
                size={32}
                round
                bgStyle={{ display: "none" }}
                iconFillColor={"black"}
              />
            </WhatsappShareButton>
            <LinkedinShareButton url={this.props.location.href}>
              <LinkedinIcon
                size={32}
                round
                bgStyle={{ display: "none" }}
                iconFillColor={"black"}
              />
            </LinkedinShareButton>
          </SocialMedia>
        </Content>
      </Layout>
    );
  }
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PostTemplate;

export const postQuery = graphql`
  query BlogPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      title
      uri
      slug
      date(formatString: "MMMM DD, YYYY")
      excerpt
      content
      seo {
        description
        title
      }
      social {
        facebook
        twitter
      }
      tags {
        nodes {
          id
          name
          description
          slug
        }
      }
      categories {
        nodes {
          id
          name
          slug
        }
      }
      featuredImage {
        image: node {
          sourceUrl
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                width: 1650
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  }
`;
